export { ProjectsComponent } from "./components/projects.component";
export { ProjectdetailsComponent } from "./components/projectdetails.component";
export { SprintComponent } from "./components/sprint.component";

export { ProjectsService } from "./services/projects.service";


// WEBPACK FOOTER //
// ./src/app/modules/work/index.ts